import ActionTypes from '../constants';

const initialState = {
    performaInvoices: {},
    performaInvoice: {},
    
};

const performaInvoiceReducer = (state = initialState, action) => {
    switch (action.type) {
        // case ActionTypes.LOADING:
        //     return {
        //         ...state,
        //         loading: true
        //     }
        case ActionTypes.GETPERFORMAINVOICESUCCESS:
            return {
                ...state,
                performaInvoices: action.payload,
            }
        case ActionTypes.GETPERFORMAINVOICEBYIDSUCCESS:
            return {
                ...state,
                performaInvoice: action.payload,
            }
        default:
            return state;
    }
}

export default performaInvoiceReducer;